import { createContext } from 'react';
import type { Target } from '@retro-ui/api-contract';

export interface SmilesError {
  index: number;
  smiles: string;
  message: string;
}

interface TargetValidationContext {
  validateTargets: (targets: Target[] | null) => Promise<SmilesError[]>;
}

export const TargetValidationContext = createContext<TargetValidationContext>({
  validateTargets: async () => [],
});
